import React from 'react'

import { FitText } from '../components/text/FitText'
import { EditableText } from '../slides/EditableText'

/**
 * The headline slot (plots plan Stage 2, AA): a slide's action title in the display
 * face. It shrinks to fit (`FitText`, 40px down to `minFontSize`) inside its
 * line budget; in edit mode it is an `EditableText` at the base size.
 *
 * The line budget and width come from the host (the preset's bound headline slot in
 * `packages/slide-schemas/layouts/`); the type is the same on every slide that uses it.
 * `FitText` has no tooltip, so a static (PDF) render needs no mode of its own here.
 */
export interface SlotHeadlineProps {
  text: string
  maxLines: number
  minFontSize?: number
  /** Fixed width where the slide sets one (matrix-categorical 647, recommendations 1252). */
  width?: number
  /** Keep `width` in edit mode too (recommendations). */
  widthWhenEditing?: boolean
  color?: string
  editable?: boolean
  onEdit?: (field: string, value: string) => void
}

export function SlotHeadline(props: SlotHeadlineProps) {
  const { text, maxLines, minFontSize = 26, width, widthWhenEditing, color = 'var(--slide-text-primary)', editable, onEdit } = props
  if (editable && onEdit) {
    return (
      <EditableText
        value={text}
        field="actionTitle"
        editable
        onEdit={onEdit}
        tag="h1"
        style={{
          fontFamily: 'var(--ds-font-display)',
          fontSize: 40,
          fontWeight: 400,
          margin: 0,
          color,
          ...(widthWhenEditing && width != null ? { width } : {}),
        }}
      />
    )
  }
  return (
    <FitText
      as="h1"
      maxLines={maxLines}
      baseFontSize={40}
      minFontSize={minFontSize}
      lineHeight={1.2}
      style={{
        fontFamily: 'var(--ds-font-display)',
        fontWeight: 400,
        margin: 0,
        color,
        ...(width != null ? { width } : {}),
      }}
    >
      {text}
    </FitText>
  )
}
